import { createFileRoute } from "@tanstack/react-router";

import Management from "~/pages/Management";
import { ROUTE_STATIC } from "~/utils/routeStaticData";

export const Route = createFileRoute("/_private/management/")({
  staticData: ROUTE_STATIC.management,
  component: Management,
});
